<div class="coupon-modal">

    <div class="coupon-form sticky-top">
        <div class="input-group form-group has-search">
            <input type="text" class="form-control" placeholder="Enter your offer code" [(ngModel)]="couponCode">
            <div class="input-group-append">
                <button mat-flat-button color="warn" (click)="apply()">Apply</button>
              </div>
          </div>
          <div class="input-group form-group has-search mt-4 referral">
            <input type="text" class="form-control" placeholder="Enter your Referral code" [(ngModel)]="referralCode">
            <div class="input-group-append">
                <button mat-flat-button color="warn" (click)="apply()">Apply</button>
              </div>
          </div>
    </div>

    <div class="coupon-list">
        <div class="coupons-card">
            <h6>AVAILABLE COUPONS</h6>

            <div class="coupon-in" *ngFor="let coupon of couponList">
                <!-- <div class="coupon-text">
                    <div>
                       {{coupon.coupon_code}}
                    </div>
                </div> -->

                <div class="d-flex align-items-center justify-content-between">
                    <div class="offerpercentage">
                        Get {{coupon.discount_amount}}/- off
                    </div>
    
                    <button mat-button (click)="applyCoupon(coupon)">{{coupon.coupon_code}}</button>
                </div>
                <div class="coupon-info">Use code {{coupon.coupon_code}} & get {{coupon.discount_amount}}/- off</div>

              
            </div>

        
        </div>
    </div>

    

</div>